import { useEffect, useCallback } from "react"
import { useSignal, batch, useComputed } from "@preact/signals-react"
import { postSubmit, isEmpty } from "@ui-seeker/utils"

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals"
import { DISPLAY_TABS } from "../@constants"
import usePricingDiscountTopMarketDispersionsRoleConfig from "./useRoleConfig"
import { elementsInLoading } from "../../../@signals"


export default function usePriceDiscountTopMarketChanges() {
	const { urlApi } = usePricingDiscountTopMarketDispersionsRoleConfig()

	const isLoading = useSignal(false)
	const data = useSignal({})
	const loadedData = useSignal(false)
	const countries = useSignal([])
	const selectedCountry = useSignal(null)
	const displayTab = useSignal(DISPLAY_TABS.TOP_HIGHER)

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoading.value = true
			data.value = {}
			countries.value = []
			selectedCountry.value = null
			loadedData.value = false
			postSubmit(`${urlApi}/market-comparison`, { ...commonFiltersValue.value }).then(res => batch(() => {
				data.value = res.marketComparison
				countries.value = res.marketComparisonCountries
				selectedCountry.value = res.marketComparisonCountries[0]
				loadedData.value = true
			})).catch(() => {
				isLoadingCommonFilters.value = false
				isSystemBusy.value = true
			}).finally(() => batch(() => {
				isLoading.value = false
			}))
		}
	}, [isLoadingCommonFilters.value]);

	useEffect(() => {
		if (isLoading.value)
			elementsInLoading.value = [...elementsInLoading.value, 'topMarketDispersions']
		else
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'topMarketDispersions')
	}, [isLoading.value])

	const currentData = useComputed(() => {
		if (displayTab.value === DISPLAY_TABS.TOP_HIGHER && !isEmpty(data.value)){
			const positiveData = data.value[selectedCountry.value].filter(item => item.minDiff > 0)
			if (positiveData?.length > 0 )
				return positiveData.sort((a, b) => b.minDiff - a.minDiff).slice(0,20) || []
		}

		if (displayTab.value === DISPLAY_TABS.TOP_LOWER && !isEmpty(data.value)){
			const negativeData = data.value[selectedCountry.value].filter(item => item.minDiff < 0)
			if (negativeData?.length > 0)
				return negativeData.sort((a, b) => a.minDiff - b.minDiff).slice(0,20) || []
		}

		return []
	})

	const handleChangeTabs = (_, newValue) => displayTab.value = newValue

	const handleSelectedCountry = useCallback(newValue => {
		selectedCountry.value = newValue
	}, [])

	return {
		isLoading: isLoading.value,
		data: data.value,
		countries: countries.value,
		selectedCountry: selectedCountry.value,
		displayTab: displayTab.value,
		currentData: currentData.value,
		loadedData: loadedData.value,
		handleChangeTabs,
		handleSelectedCountry
	}
}